import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const VoidedApplicationsContainer = () => {
    const ApplStatus = "11";
    const Title = "Voided Applications";
    const Desc = "Displays all applications that have been marked as void. This administrator-only module provides a centralized view of voided application records for auditing, record management, and reference purposes.";
    return (
        <>
        <Breadcrumbs mainTitle="Voided Applications" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default VoidedApplicationsContainer;
